import { HttpFailedRequestError } from "@core/domain/infrastructures/http/errors/http-failed-request.error";

export class HttpUnprocessableContentError extends HttpFailedRequestError {
    static readonly CODE = 422;

    constructor(errorDescription?: string) {
        super(HttpUnprocessableContentError.CODE, undefined, errorDescription);

        Object.setPrototypeOf(this, HttpUnprocessableContentError.prototype);
    }
}
